<template>
  <div>
    <v-col>
      <v-row class="mb-4">
        <v-col class="headline text-center">
          <h3>{{ fields.title }}</h3>
        </v-col>
      </v-row>
      <v-row class="justify-center justify-md-space-between">
        <iol-text-field class="col-md-3" :fields="field.patientID" />
        <iol-text-field class="col-md-3" :fields="field.keratometric_index" />
        <iol-text-field class="col-md-3" :fields="field.biometer" />
      </v-row>
      <v-divider cols="12" />
    </v-col>
  </div>
</template>

<style></style>

<script>
import IolTextField from '@/components/elementary/IolTextField.vue'

export default {
  name: 'iol-result-header',
  props: ['fields'],
  components: {
    IolTextField,
  },
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>
